<script setup lang="ts">
const open = defineModel<boolean>('open', {
  default: false,
  type: Boolean,
})

const router = useRouter()
const { t } = useI18n()

function handleViewCart() {
  open.value = false
  router.push('/cart')
}

function handleCheckout() {
  open.value = false
  router.push('/checkout')
}

function handleProductClick() {
  open.value = false
}
</script>

<template>
  <UiDrawer v-model:open="open">
    <UiDrawerContent>
      <!-- Success indicator and title -->
      <div class="flex flex-col items-center py4">
        <div class="bg-success-100 mb-3 h-12 w-12 flex items-center justify-center rounded-full">
          <Icon name="i-heroicons:check" class="h-6 w-6 text-success" />
        </div>
        <UiDrawerTitle class="text-center">
          {{ t('cart.item_added_to_cart') }}
        </UiDrawerTitle>
        <p class="mt-1 text-sm text-muted-foreground">
          {{ t('cart.continue_shopping_or_checkout') }}
        </p>
      </div>

      <div class="pb-6 space-y-6">
        <!-- Action buttons -->
        <div class="grid grid-cols-2 gap-3 px-4">
          <UiButton
            variant="outline"
            size="lg"
            class="w-full"
            @click="handleViewCart"
          >
            <Icon name="i-heroicons:shopping-bag" class="mr-2 h-4 w-4" />
            {{ t('checkout.goto_cart.label') }}
          </UiButton>
          <UiButton
            size="lg"
            variant="success"
            class="w-full text-white"
            @click="handleCheckout"
          >
            {{ t('checkout.label') }}
            <Icon name="i-heroicons:arrow-right" class="ml-2 h-4 w-4" />
          </UiButton>
        </div>

        <!-- Upsell Carousel -->
        <div class="px-4 space-y-4">
          <CartUpsellCarousel
            carousel-item-class="basis-[45%] pl-2"
            @product-click="handleProductClick"
          >
            <template #title>
              <div>
                <h3 class="text-base font-semibold">
                  {{ t('product.recommended_for_you') }}
                </h3>
                <p class="text-sm text-muted-foreground">
                  {{ t('product.customers_also_bought') }}
                </p>
              </div>
            </template>
          </CartUpsellCarousel>
        </div>
      </div>
      <OrderCountdown class="mb0 pb0 [&>div.countdown-wrapper]:rd-none" />
    </UiDrawerContent>
  </UiDrawer>
</template>
